import { Agent } from "./types";

export const STORAGE_KEY = "dumont_chat_conversations";

export const AGENTS_PAGE_SIZE = 3;

export const NO_PARENT = "00000000-0000-0000-0000-000000000000";

// Configurações do Chat
export const CHAT_CONFIG = {
  MAX_TITLE_LENGTH: 50,
  TITLE_ELLIPSIS: "...",
  DUMONT_RESPONSE_DELAY_MS: 1000,
  // Note: DEFAULT_DUMONT_RESPONSE should use translation key 'dumontDefaultResponse' in components
  DEFAULT_DUMONT_RESPONSE: "Thank you for reaching out! I'm analyzing your request and will provide the best solution.",
} as const;

// Larguras do layout do DumontSidebar
export const SIDEBAR_TOTAL_WIDTH = 507; // Largura total do sidebar (navbar + chat)
export const SIDEPANEL_NAVBAR_WIDTH = 70; // Largura da navbar lateral
export const CHAT_PANEL_WIDTH_DESKTOP = 437; // Largura do painel de chat
export const FULLSCREEN_SIDEBAR_WIDTH = 279; // Largura da sidebar em modo fullscreen

// Z-indexes para camadas de UI
export const Z_INDEX_SIDEBAR = 10;
export const Z_INDEX_FULLSCREEN = 1300;
export const Z_INDEX_BACKDROP = 1249;
export const Z_INDEX_HELP_MODAL_BACKDROP = 1400;
export const Z_INDEX_HELP_MODAL = 1401;

// Note: Agent names, descriptions and categories should use translation keys in components:
// - name: 'dumontBusinessAssistant', 'dumontOperationsAssistant', 'dumontWarehousingAssistant'
// - description: 'dumontBusinessAssistantDesc', 'dumontOperationsAssistantDesc', 'dumontWarehousingAssistantDesc'
// - category: 'dumontSales', 'dumontOperations', 'dumontLogistics'
export const DEFAULT_AGENTS: Agent[] = [
  {
    id: "1",
    name: "Business Assistant",
    description: "Specialized in sales and quotes",
    icon: "business",
    category: "Sales",
  },
  {
    id: "2",
    name: "Operations Assistant",
    description: "All of your operations expert",
    icon: "operations",
    category: "Operations",
  },
  {
    id: "3",
    name: "Warehousing Assistant",
    description: "Inventory and warehouse operations expert",
    icon: "warehouse",
    category: "Logistics",
  },
];


